import { breakpoint } from '@ovpn/ui/tokens';
export const breakPoints = {
    XS: breakpoint.sm - 1,
    SM: 768,
    MD: 992,
    LG: 1200,
    XLG: 1366,
};

/**
 * @deprecated remove usage
 */
export const sidebarTheme: any = {} as const;
